// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3UxQv","label":"Category_label__TJ5aa","content":"Category_content__qUUAB","header":"Category_header__1dfaK","location":"Category_location__2WJem"};